export function getLadderPrice(data:any,num:Number) {
  if(data.tagInfo && data.tagInfo['1234']){
    let rule = data.tagInfo['1234'].rule;
    data.salePrice = data.tagInfo['1234'].price;
    for(let i=(rule.length-1);i>=0;i--){
      if(num>=rule[i].quantity){
          data.salePrice = rule[i].price;
          break;
      }
    }
  }
}

